module.exports = __webpack_public_path__ + "img/Sunny.92f83382.jpeg";